var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isAllowedType(_vm.options.type))?_c(`${_vm.options.type}-field`,{tag:"component",attrs:{"options":_vm.options,"value":_vm.modelValue},on:{"update:value":function($event){_vm.modelValue=$event}}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }